import { get } from "lodash";
import React from "react";
import { useFormContext } from "react-hook-form";

import "./styles.scss";
import { HookFormError } from "../Error";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
}

export const Input = (props: InputProps) => {
  const { register, formState } = useFormContext();

  const error = get(formState, `errors.${props.name}.message`, null);

  return (
    <>
      <input className="hook-form-input" {...props} {...register(props.name)} />
      {error && (
        <div className="hook-form-status-display">
          <HookFormError error={error} />
        </div>
      )}
    </>
  );
};
